// Centralized status color definitions and helpers

export const STATUS_PALETTES = {
  confirmed: { color: "#0F9960", background: "rgba(15, 153, 96, 0.12)", border: "rgba(15, 153, 96, 0.4)" },
  billed: { color: "#0F9960", background: "rgba(15, 153, 96, 0.12)", border: "rgba(15, 153, 96, 0.4)" },
  discharged: { color: "#137CBD", background: "rgba(19, 124, 189, 0.12)", border: "rgba(19, 124, 189, 0.4)" },
  postponed: { color: "#D9822B", background: "rgba(217, 130, 43, 0.12)", border: "rgba(217, 130, 43, 0.4)" },
  // Discharged but not billed (requested to be orange)
  discharged_not_billed: { color: "#D9822B", background: "rgba(217, 130, 43, 0.12)", border: "rgba(217, 130, 43, 0.4)" },
  cancelled: { color: "#DB3737", background: "rgba(219, 55, 55, 0.12)", border: "rgba(219, 55, 55, 0.4)" },
  // Additional known statuses for other screens
  scheduled: { color: "#106BA3", background: "rgba(16, 107, 163, 0.12)", border: "rgba(16, 107, 163, 0.4)" },
  completed: { color: "#0F9960", background: "rgba(15, 153, 96, 0.12)", border: "rgba(15, 153, 96, 0.4)" },
  pending: { color: "#8F3985", background: "rgba(143, 57, 133, 0.12)", border: "rgba(143, 57, 133, 0.4)" },
  rescheduled: { color: "#8F3985", background: "rgba(143, 57, 133, 0.12)", border: "rgba(143, 57, 133, 0.4)" },
};

export const toTitleCase = (value) => {
  if (!value) return "-";
  return String(value)
    .replace(/_/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

export const getStatusMeta = (status) => {
  const normalized = String(status || "-").toLowerCase();
  const label = toTitleCase(status);
  const palette = STATUS_PALETTES[normalized] || {
    color: "#5C7080",
    background: "rgba(92, 112, 128, 0.12)",
    border: "rgba(92, 112, 128, 0.35)",
  };
  return {
    label,
    color: palette.color,
    background: palette.background,
    border: palette.border,
  };
};

// Case-insensitive CASH matcher
const isCashPanel = (panel) => {
  try {
    return String(panel || "").trim().toLowerCase() === "cash";
  } catch (e) {
    return false;
  }
};

// Derive displayed status meta from payorPanel + status + isBilled
// Returns same shape as getStatusMeta
export const getDisplayStatusMeta = ({ status }) => {
  return getStatusMeta(status);
};


